var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpLevelJobCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Professional-Info",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PROFILE---Professional-Info-(Desktop)",
    transform: "translate(-601.000000, -749.000000)",
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M609.8,752.333333 L614.2,752.333333 C614.2,751.666667 613.76,751.222222 613.1,751.222222 L610.9,751.222222 C610.24,751.222222 609.8,751.666667 609.8,752.333333 M601,755.111111 C601.33,753.555556 602.65,752.333333 604.3,752.333333 L607.6,752.333333 C607.6,750.444444 609.03,749 610.9,749 L613.1,749 C614.97,749 616.4,750.444444 616.4,752.333333 L619.7,752.333333 C621.35,752.333333 622.78,753.444444 623,755.111111 C622.78,756.777778 621.35,757.888889 619.7,757.888889 L604.3,757.888889 C602.65,757.888889 601.33,756.666667 601,755.111111 M623,759 L623,765.666667 C623,767.555556 621.57,769 619.7,769 L604.3,769 C602.43,769 601,767.555556 601,765.666667 L601,759 C601.99,759.777778 603.09,760.111111 604.3,760.111111 L619.7,760.111111 C620.91,760.111111 622.01,759.777778 623,759",
    id: "Fill-1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpLevelJobCard);
export default __webpack_public_path__ + "static/media/expLevelJobCard.f77b6fd5.svg";
export { ForwardRef as ReactComponent };